<template>
  <div>
    <div class="site-footer">
      <div class="container-w d-flex">
        <el-row>
          <el-col :span="10" class="footer-row">
            <el-row>
              <el-col :span="8">
                <ul>
                  <li class="t">{{$t('pc.footer.about_us')}}</li>
                  <li>
                    <router-link to="/help/helpabout">
                      {{$t('pc.footer.company_profile')}}
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/help/helpqualification">
                      {{$t('pc.footer.company_qualification')}}
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/help/helpagreement">
                      {{$t('pc.footer.registration_agreement')}}
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/help/helpcontact">
                      {{$t('pc.footer.contact_us')}}
                    </router-link>
                  </li>
                </ul>
              </el-col>
              <el-col :span="8">
                <ul>
                  <li class="t">{{$t('pc.home.want_to_allocate_funds')}}</li>
                  <li>
                    <router-link to="/operate/operateday">
                      {{$t('pc.home.day_capital')}}
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/operate/operateweek">
                      {{$t('pc.home.week_capital')}}
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/operate/operatemonth">
                      {{$t('pc.home.month_capital')}}
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/operate/operatehuhui">
                      {{$t('pc.home.interest_free_capital')}}
                    </router-link>
                  </li>
                </ul>
              </el-col>
              <el-col :span="8">
                <ul>
                  <li class="t">{{$t('pc.footer.help_center')}}</li>
                  <li>
                    <router-link to="/help/helpguidelines">
                      {{$t('pc.footer.beginner_guide')}}
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/login/register">
                      {{$t('pc.footer.money_with_promotion')}}
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/download">
                      {{$t('pc.home.app_download')}}
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/help/helpcenter">
                      {{$t('pc.footer.faq')}}
                    </router-link>
                  </li>
                </ul>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="6" class="qr-list" style="margin-right: 80px;">
            <div class="qr-item" style="margin-left: 115px;">
              <div id="QrCode"></div>
              <span>{{ $t(codes[0].title) }}</span>
            </div>
          </el-col>
          <!-- <el-col :span="3" class="qr-list">
            <div class="qr-item">
              <img src="../assets/img/dnsdgzh.jpg" style="width: 120px;height: 120px;margin: 0" >
              <span>香港大牛公众号</span>
            </div>
          </el-col> -->
          <el-col :span="6" class="work-info">
            <h3>{{$t('pc.footer.service_hotline')}}</h3>
            <h2>{{ phone[0] }}</h2>
            <p>{{$t('pc.footer.business_hours')}}（08:30-20:30）<br>
              {{$t('pc.footer.statutory_holidays')}}（13:00-20:00）</p>
          </el-col>
        </el-row>
        <div class="version-text">
          <span style="margin-right: 10px;">版本号 : {{ version }}</span><span>包号 : {{ description }}</span>
        </div>
      </div>
    </div>
    <div class="copyright" style="padding-top:20px;">
      <div class="container-w footer-row">
        <a href="javascript:void(0);"><img :src="pc_bottom_img.image_1" height="47px" width="127px" alt=""></a>
        <a href="javascript:void(0);"><img :src="pc_bottom_img.image_2" height="47px" width="127px"></a>
        <!-- <a href="javascript:void(0);"><img src="../assets/img/hy_124x47.png" height="47px" width="127px"></a> -->
        <a href="javascript:void(0);"><img :src="pc_bottom_img.image_3" height="47px" width="127px"></a>
        <a href="javascript:void(0);"><img :src="pc_bottom_img.image_4" height="47px" width="127px"></a>
        <!-- <a href="javascript:void(0);"><img src="../assets/img/shuidi.png" height="47px" width="127px"></a> -->
        <a href="javascript:void(0);"><img :src="pc_bottom_img.image_5" height="47px" width="127px"></a>
        <a href="javascript:void(0);"><img :src="pc_bottom_img.image_6" height="47px" width="127px"></a>
      </div>
      <div class="container-w" style="font-size:16px;margin-top:10px;">
        Copyright © {{ copyright }}| All Rights Reserved{{$t('pc.footer.investment_risky')}}    </div>
    </div>
  </div>
</template>
<script>
import QRCode from 'qrcodejs2';
import { version,description } from './../../package.json';
export default {
  name: "Footer",
  data() {
    return {
      phone: ["", ""], //电话
      codes: [
        { code: "", title: "" },
        { code: "", title: "" },
        { code: "", title: "" }
      ], //微信二维码
      qq: [""], //QQ
      copyright: "", //版权
      link: [], //友情链接
      pc_bottom_img: "",
      version:version,
      description:description
    };
  },
  mounted: function() {
    this.getFooterData();
    this.pcBottomImg();
  },
  methods: {
    pcBottomImg() {
      let that = this;
      that.$http({
        url: "/",
        method: "POST",
        data: {
          'nozzle': 'pc_home',
        }
      })
        .then(ret => {
          let resData = ret.data;
          if (resData.code === 1) {
            that.pc_bottom_img = resData.data.pc_bottom_img;
          }
        });
    },
    QrCode(url) {
      new QRCode('QrCode', {
        width: 120,
        height: 120,
        text: url, // 二维码地址
      })
    },
    //获取页面底部信息
    getFooterData() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "web_common"
          }
        })
        .then(function(res) {
          if (res.data.code == 1) {
            var data = res.data.data;
            that.phone = data.phone;
            that.codes = data.codes;
            that.qq = data.qq;
            that.copyright = data.copyright;
            that.link = data.link;
            that.QrCode(that.codes[0].code);
          } else if (res.data.code == 0) {
            that.$message.error(that.$t(res.data.msg));
          }
        });
    }
  }
};
</script>
<style scoped>
  @import url("./../assets/css/style.css");

  .footer-row ul{
    margin:0;
    padding:0;
    font-size:16px;
    line-height: 27px;
    text-align: center;
  }
  .footer-row ul li {
    list-style:none;
  }

  .footer-row ul li a{
    color: #fff;
  }

  .footer-row .t{
    font-size:18px;
    font-weight: bolder;
    padding-bottom:5px;
  }

  .version-text{
    font-size: 10px;
    margin-top: 20px;
    color: white  ;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: -5px;
  }
</style>





// WEBPACK FOOTER //
// src/components/footer.vue